import PropTypes from 'prop-types';
import React, { useEffect } from "react";
import { Routes, Route } from 'react-router-dom';
import { connect } from "react-redux";

// Import Routes all
import { userRoutes } from "./routes/allRoutes";

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware";

// layouts Format
import NonAuthLayout from "./components/NonAuthLayout";

import LoginPage from './features/auth/components/Login';
import ForgotPassword from './features/auth/components/ForgotPassword';

// import "./App.css"
// Import scss
import "./assets/scss/theme.scss";
import "./assets/css/main.css";
import "./assets/css/style-new.css";
import "./assets/css/responsive.css";
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.min.css';               
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import RegistrationPage from './features/auth/components/Registration';
import AutoLogin from './features/auth/components/Autologin';
import Notfound from './components/vertical-layout/Notfound';
import { getDeviceTokenView, messaging } from './components/CommonForBoth/topbar-dropdown/FireBaseConfig';
import { onMessage } from 'firebase/messaging';
import { getCookie } from './helpers/cookie';
const App = () => {
  const UserInfo = JSON.parse(getCookie('user_info') || '{}');
 useEffect(() => {
    if (UserInfo) {
      getDeviceTokenView()
      onMessage(messaging, (payload) => {
        console.log(payload)

      }

      )
    }
  }, []);
  return (
    <React.Fragment>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/auto-login" element={<AutoLogin />} />
        <Route path="/notfound" element={<Notfound /> }/>
        
        {/* Protected routes */}  
        {userRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                {route.component}
              </Authmiddleware>}
            key={idx}
            exact={true}
          />
        ))}
      </Routes>
    </React.Fragment>

  );
};

App.propTypes = {
  layout: PropTypes.any
};

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  };
};

export default connect(mapStateToProps, null)(App);
